export const dbsKeys = {
  provinces: "dbs.provinces.v1",
  deals: "dbs.deals.v1",
};
